export const GET_POPUP_LIST = "GET_POPUP_LIST";
export const POST_POPUP = "POST_POPUP";
export const CREATE_POPUP = "CREATE_POPUP";
export const SHOW_POPUP = "SHOW_POPUP";
export const UPDATE_POPUP = "UPDATE_POPUP";
export const DELETE_POPUP = "DELETE_POPUP";
export const UPDATE_STATUS_POPUP = "UPDATE_STATUS_POPUP";
